// Application-wide configurations
import './vue'
import api from './api'

export default {
  api
}



// WEBPACK FOOTER //
// ./src/config/index.js